'use client'

import { useEffect, useState } from 'react'

import { cn } from '@/core/utils/common'

type DetailTabsProps = {
  sections: { id: string; label: string }[]
}

export default function DetailTabs({ sections }: DetailTabsProps) {
  const [active, setActive] = useState(sections[0]?.id)

  useEffect(() => {
    const elements = sections
      .map((section) => document.getElementById(section.id))
      .filter((element): element is HTMLElement => element !== null)
    const update = () => {
      const line = window.innerWidth > 1000 ? 220 : 140
      const current = elements.filter(
        (element) => element.getBoundingClientRect().top <= line
      )
      setActive(current.at(-1)?.id ?? sections[0]?.id)
    }
    update()
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [sections])

  return (
    <nav
      aria-label="상품 정보"
      className="sticky top-16 z-20 border-b border-border bg-background over10:top-[136px]"
    >
      <div className="scrollbar-none flex gap-5 overflow-x-auto over10:gap-7">
        {sections.map((section) => (
          <a
            key={section.id}
            href={`#${section.id}`}
            aria-current={section.id === active ? 'true' : undefined}
            className={cn(
              'type-ui -mb-px shrink-0 border-b-2 py-3.5',
              section.id === active
                ? 'border-foreground font-semibold text-foreground'
                : 'border-transparent text-description hover:text-foreground'
            )}
          >
            {section.label}
          </a>
        ))}
      </div>
    </nav>
  )
}
